module.exports = __webpack_public_path__ + "img/model.0e6b6438.png";